import SeatMap from './SeatMap';

export default SeatMap;
